import * as types from './types'
import * as getters from './getters'
import * as actions from './actions'

const state = {
  categories: []
}

const mutations = {
  [types.RECEIVE_CATEGORIES] (state, data) {
    state.categories = data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/categories/index.js